





































































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import Api from '@/api/order/orderLogs/index'
import { FormItem } from '../../types/iview/form'
@Component({
  components: {
    CustomForm,
  },
})
export default class CommissionList extends AbpBase {
  filters = [
    {
      label: '开始时间',
      type: 'date',
      props: {
        placeholder: '请选择开始日期',
      },
      key: 'startTime',
    },
    {
      label: '结束时间',
      type: 'date',
      props: {
        placeholder: '请选择结束日期',
      },
      key: 'endTime',
    },
  ]
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '姓名',
      key: 'name',
      align: 'center',
       width: 100,
    },
    {
      title: '导购编码',
      key: 'employeeCode',
      align: 'center',
      width: 120,
      // width: 200
    },
    {
      title: '身份证号',
      key: 'idCard',
      align: 'center',
      width: 160,
    },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
      width: 120
    },
    {
      title: '职位',
      key: 'position',
      align: 'center',
      width: 120
    },
    {
      title: '所属办事处',
      key: 'department',
      align: 'center',
      width: 200,
    },
    {
      title: '店铺编码',
      key: 'shopCode',
      align: 'center',
      width: 120
    },
    {
      title: '注册时间',
      slot: 'registerTime',
      key: 'registerTime',
      align: 'center',
      width: 140,
    },
    {
      title: '提佣时间',
      key: 'createTime',
      slot: 'createTime',
      align: 'center',
      width: 140,
    },
    {
      title: '提现金额',
      key: 'withdrawnCash',
      align: 'center',
      width: 120
    },
    {
      title: '剩余金额',
      key: 'remainingCash',
      align: 'center',
      width: 120
    },
    {
      title: '审核时间',
      slot: 'CheckTime',
      align: 'center',
      width: 140,
    },
    {
      title: '开始时间',
      key: 'startTime',
      slot: 'startTime',
      align: 'center',
      width: 140,
    },
    {
      title: '结束时间',
      key: 'endTime',
      slot: 'endTime',
      align: 'center',
      width: 140,
    },
    // {
    //   title: '操作',
    //   slot: 'action',
    //   width: 200,
    //   align: 'center',
    // },
  ]
  exporting: boolean = false
  copyData = []
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  mounted() {
    this.loadData()
  }
  submitChange(form, valid) {
    if (valid) {
      console.log(form)
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    let startTime = form['startTime']
      ? this.dateString(form['startTime'])
      : null
    let endTime = form['endTime'] ? this.dateString(form['endTime']) : null
    Api.statisCommissionList(
      startTime,
      endTime,
      this.pager.pageSize,
      this.pager.pageIndex
    ).then((res) => {
      this.pager.total = res.data.totalCount
      this.copyData = res.data.items
      // console.log('提佣佣金统计列表', res)
    })
  }
  onPageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData((this.$refs.lineForm as any).form)
  }
  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    console.log(form)
    let startTime = form['startTime']
    let endTime = form['endTime']
    Api.exportWidthdrawReportFile(
      this.pager.pageSize,
      this.pager.pageIndex,
      startTime,
      endTime
    )
      .then((res) => {
        console.log(res);
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '提佣统计表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
  // distributorDetailFn(row) {
  //   console.log(row);
  // }
}
